import React from "react";

import { Box, Flex, Text, Heading, VStack, Image } from "@chakra-ui/react";

import Flower from "../SVG/Flower";

// Fades the artwork out toward every edge so the PNG's rectangular
// crop never shows against the page background.
const DRAGON_MASK = "linear-gradient(to right, #000 65%, transparent 100%)";

function Dragon({ flip = false, ...position }) {
  return (
    <Box
      position="absolute"
      zIndex={0}
      pointerEvents="none"
      opacity={{ base: 0.35, md: 0.8, lg: 0.9 }}
      {...position}
    >
      <Image
        src="/dragon.png"
        alt=""
        aria-hidden="true"
        width={{ base: "220px", md: "280px", lg: "330px" }}
        height="auto"
        transform={flip ? "scaleX(-1)" : undefined}
        sx={{ maskImage: DRAGON_MASK, WebkitMaskImage: DRAGON_MASK }}
      />
    </Box>
  );
}

// Menu-style row: label on the left, dotted leader, value on the right.
function OfferRow({ label, value }) {
  return (
    <Flex align="baseline" width="100%">
      <Text as="span" whiteSpace="nowrap">
        {label}
      </Text>
      <Box
        flex="1"
        mx="0.75rem"
        borderBottom="1px dotted"
        borderColor="whiteAlpha.500"
      />
      <Text as="span" whiteSpace="nowrap">
        {value}
      </Text>
    </Flex>
  );
}

const offerTitleStyle = {
  fontSize: { base: "22px", md: "30px" },
  lineHeight: 1.3,
};

const rowListStyle = {
  width: "100%",
  maxW: "380px",
  spacing: "0.75rem",
  align: "stretch",
  fontSize: { base: "16px", md: "18px" },
};

function Offers() {
  return (
    <Flex
      color="whiteaccent"
      justify="center"
      zIndex={1}
      position="relative"
      overflow="hidden"
    >
      <Dragon flip top="5rem" left={{ base: "-8rem", md: "-2rem", lg: "0" }} />
      <Dragon bottom="5rem" right={{ base: "-8rem", md: "-2rem", lg: "0" }} />

      <Flex
        my="5rem"
        px={{ base: "1.25rem", md: 0 }}
        width="100%"
        direction="column"
        align="center"
        textAlign="center"
        fontFamily="innerbody"
        zIndex={1}
        position="relative"
      >
        <Flex borderBottomWidth="2px" borderColor="white" position="relative">
          <Heading
            as="h1"
            textAlign="center"
            fontSize={{ base: "30px", md: "44px" }}
            fontWeight={400}
            letterSpacing={1}
            mb="1rem"
            fontFamily="innerbody"
          >
            DEALS & OFFERS
          </Heading>
          <Flex
            position="absolute"
            left="0"
            right="0"
            bottom="-15px"
            justify="center"
          >
            <Flower padding={"9px"} background={"primary"} color={"#F5F5F5"} />
          </Flex>
        </Flex>

        <Text
          mt="5rem"
          fontWeight={700}
          fontSize={{ base: "20px", md: "24px" }}
          letterSpacing="0.08em"
        >
          TAKE-OUT OFFERS
        </Text>

        <Text mt="2.5rem" {...offerTitleStyle}>
          Discount on pick-up orders over $35 (before GST)
        </Text>
        <VStack mt="1.5rem" {...rowListStyle}>
          <OfferRow label="Cash" value="10% off" />
          <OfferRow label="Credit/Debit" value="5% off" />
        </VStack>

        <Flex align="center" width="100%" maxW="320px" my="3.5rem">
          <Box flex="1" height="1px" bg="whiteAlpha.500" />
          <Text
            mx="1rem"
            fontSize={{ base: "18px", md: "20px" }}
            letterSpacing="0.2em"
          >
            OR
          </Text>
          <Box flex="1" height="1px" bg="whiteAlpha.500" />
        </Flex>

        <Text {...offerTitleStyle}>
          Free item on orders over $40 (before GST)
        </Text>
        <VStack mt="1.5rem" {...rowListStyle}>
          <OfferRow label="Spring Rolls" value="over $40" />
          <OfferRow label="Chicken Fried Rice" value="over $60" />
          <OfferRow label="Ginger Beef" value="over $80" />
          <OfferRow label="Salt & Pepper Squid" value="over $90" />
        </VStack>

        <Text mt="4rem" maxW="520px" fontSize="14px">
          *Not valid on Mother’s Day, Father’s Day, Christmas Eve, New Year’s
          Eve, New Year’s Day
        </Text>
      </Flex>
    </Flex>
  );
}

export default Offers;
